import React from "react";
import clsx from "clsx";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  className,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseClasses =
    "inline-flex items-center justify-center font-black rounded-pill transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";

  const variantClasses = {
    primary: "bg-brand-primary text-brand-surface border border-brand-primary hover:opacity-90 focus:ring-brand-primary",
    secondary: "bg-brand-accent text-brand-surface border border-brand-accent hover:opacity-90 focus:ring-brand-accent",
    outline: "border border-brand-primary bg-transparent text-brand-primary hover:bg-brand-primary/5 focus:ring-brand-primary",
    ghost: "text-brand-muted hover:bg-brand-primary/5 focus:ring-brand-primary",
  };

  const sizeClasses = {
    sm: "px-5 py-1.5 text-xs",
    md: "px-7 py-2.5 text-sm",
    lg: "px-9 py-3 text-base",
  };

  return (
    <button
      className={clsx(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
